import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AcademicSelfView } from "@/features/academy/components/people/academic-self-view";

export const profileAcademicRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/academic",
  component: AcademicSelfView,
});
